import { createFileRoute } from '@tanstack/react-router';

import { SocialAdTemplateFormView } from 'src/sections/admin/social-ad-templates/social-ad-template-form-view';

export const Route = createFileRoute('/admin-skidog/social-ad-templates/$id')({
  component: EditSocialAdTemplatePage,
});

function EditSocialAdTemplatePage() {
  const { id } = Route.useParams();
  return <SocialAdTemplateFormView templateId={id} />;
}
